import  gql  from 'graphql-tag'

export const creditRates = gql`query creditRates{ 
    creditRates{
            edges{
                node{
                    id,
                    data
                }
            }
        }
    }`;
